import { Injectable } from '@angular/core';
import { PageConfig } from '../models/configs/page-config';
import { DecoratorFactory } from '../decoration-base/decorator-factory';
import { DecoratorService } from '../decoration-base/decorator.service';

/**
 * Unique key for SidebarNavMenuItem decorator.
 */
export const SIDE_BAR_KEY = 'sidebar';

/**
 * Create sidebar navigation menu item decorator
 */
export const SidebarNavMenuItem = DecoratorFactory.create<PageConfig>(SIDE_BAR_KEY);
